import { ErrorPage } from '@/components/error-page';
import { LockedArt } from '@/components/illustrations';

/**
 * Said out loud rather than a silent bounce to the dashboard: someone following a link a
 * colleague sent should learn it is a permission they lack, not wonder whether the link broke.
 */
export function ForbiddenPage() {
  return (
    <ErrorPage
      code={403}
      art={LockedArt}
      title="You don't have access to this page"
      body="It needs a role your account doesn't have. If you think it should, ask HR."
    />
  );
}
